import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { NotificationsManagementComponent } from './notifications-management.component';
import { NotificationsService } from '@fuse/services/notifications/notifications.service';
import { MatIconModule, MatButtonModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatSnackBarModule } from '@angular/material';
import { NotificationListComponent } from './notification-list/notification-list.component';

const routes = [
    {
        path: 'notifications',
        component: NotificationsManagementComponent
    }
];

@NgModule({
    declarations: [
        NotificationsManagementComponent,
        NotificationListComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatSnackBarModule
    ],
    providers: [
        NotificationsService
    ],
    exports: [
        NotificationsManagementComponent
    ]
})

export class NotificationsManagementModule {
}
